<template>
  <div>
    <b-card>
      <b-row class="mb-3">
        <b-col sm="12">
          <ul>
            <li v-for="(filename, key) in computedFiles" :key="key">
              <span style="cursor: pointer; text-decoration: underline" v-text="filename" @click="downloadFtpFile(filename)"/>
            </li>
          </ul>
          <div v-show="computedFiles.length == 0">
            No Files
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ['files'],
  methods: {
    downloadFtpFile(filename) {
      const url = '/admin/download-ftp-files'
      axios({
        url,
        method: 'POST',
        responseType: 'blob',
        data: {filename},
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  computed: {
    computedFiles() {
      if (!Array.isArray(this.files)) {
        return []
      }
      return this.files
    },
  },
}
</script>

<style>

</style>
